module.exports = __webpack_public_path__ + "static/media/order-car-dark.913d4bd2.svg";